// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateApp_draftHint__8Jmeq {
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
}

/* ───────────────────────── Questionnaire (Step 3) ───────────────────────── */

.CreateApp_questionnaireSection__3U0qE {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.CreateApp_questionnaireHeader__nfOzq {
  margin-bottom: 4px;
}

.CreateApp_questionnaireHeader__nfOzq h4 {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 600;
  color: #0a0a0a;
}

.CreateApp_questionnaireHeader__nfOzq p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

.CreateApp_questionTile__RUYyx {
  padding: 20px 22px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.CreateApp_questionLabelRow__Neu49 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.CreateApp_questionLabel__l\\+CVh {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0a0a0a;
  margin-bottom: 4px;
}

.CreateApp_questionSubtext__CqD\\+\\+ {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.CreateApp_questionInfoBtn__aTnA1 {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.CreateApp_questionInfoBtn__aTnA1:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #f0f7ff;
}

.CreateApp_questionInfoPanel__gVPls {
  margin-bottom: 16px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #3b82f6;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.7;
  color: #334155;
}

.CreateApp_questionInfoPanel__gVPls p {
  margin: 0 0 10px 0;
}

.CreateApp_questionInfoPanel__gVPls p:last-child {
  margin-bottom: 0;
}

.CreateApp_questionInfoPanel__gVPls ul {
  margin: 8px 0;
  padding-left: 20px;
}

.CreateApp_questionInfoPanel__gVPls li {
  margin-bottom: 6px;
}

.CreateApp_choiceRow__A\\+7so {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.CreateApp_choiceCard__rXB2j {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  text-align: left;
}

.CreateApp_choiceCard__rXB2j:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.CreateApp_choiceCard__rXB2j input[type="radio"],
.CreateApp_choiceCard__rXB2j input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.CreateApp_choiceCardActive__sFerY {
  border-color: #3b82f6;
  background: #f0f7ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.CreateApp_choiceIcon__mSkuz {
  font-size: 22px;
  line-height: 1;
  margin-bottom: 4px;
}

.CreateApp_choiceTitle__ppMzc {
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  line-height: 1.3;
}

.CreateApp_choiceHint__-OjoG {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .CreateApp_questionLabelRow__Neu49 {
    flex-direction: column;
    align-items: flex-start;
  }

  .CreateApp_questionInfoBtn__aTnA1 {
    align-self: flex-start;
  }

  .CreateApp_choiceRow__A\\+7so {
    grid-template-columns: 1fr;
  }
}

/* ───────────────────────── Questionnaire (Step 3) ───────────────────────── */

.CreateApp_questionnaireSection__3U0qE {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.CreateApp_questionnaireHeader__nfOzq {
  margin-bottom: 4px;
}

.CreateApp_questionnaireHeader__nfOzq h4 {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 600;
  color: #0a0a0a;
}

.CreateApp_questionnaireHeader__nfOzq p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

.CreateApp_questionTile__RUYyx {
  padding: 20px 22px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.CreateApp_questionLabelRow__Neu49 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.CreateApp_questionLabel__l\\+CVh {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0a0a0a;
  margin-bottom: 4px;
}

.CreateApp_questionSubtext__CqD\\+\\+ {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.CreateApp_questionInfoBtn__aTnA1 {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.CreateApp_questionInfoBtn__aTnA1:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #f0f7ff;
}

.CreateApp_questionInfoPanel__gVPls {
  margin-bottom: 16px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #3b82f6;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.7;
  color: #334155;
}

.CreateApp_questionInfoPanel__gVPls p {
  margin: 0 0 10px 0;
}

.CreateApp_questionInfoPanel__gVPls p:last-child {
  margin-bottom: 0;
}

.CreateApp_questionInfoPanel__gVPls ul {
  margin: 8px 0;
  padding-left: 20px;
}

.CreateApp_questionInfoPanel__gVPls li {
  margin-bottom: 6px;
}

.CreateApp_choiceRow__A\\+7so {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.CreateApp_choiceCard__rXB2j {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  text-align: left;
}

.CreateApp_choiceCard__rXB2j:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.CreateApp_choiceCard__rXB2j input[type="radio"],
.CreateApp_choiceCard__rXB2j input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.CreateApp_choiceCardActive__sFerY {
  border-color: #3b82f6;
  background: #f0f7ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.CreateApp_choiceIcon__mSkuz {
  font-size: 22px;
  line-height: 1;
  margin-bottom: 4px;
}

.CreateApp_choiceTitle__ppMzc {
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  line-height: 1.3;
}

.CreateApp_choiceHint__-OjoG {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 640px) {
  .CreateApp_questionLabelRow__Neu49 {
    flex-direction: column;
    align-items: flex-start;
  }

  .CreateApp_questionInfoBtn__aTnA1 {
    align-self: flex-start;
  }

  .CreateApp_choiceRow__A\\+7so {
    grid-template-columns: 1fr;
  }
}

.CreateApp_modalOpener__r7Ri4 {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

/* Bot Section Styles - Updated */
.CreateApp_botSection__a36B3 {
  padding: 4px 0;
  width: 100%;
}
.CreateApp_wrap_welcome_message__qKUuC {
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  transition: border-color 0.2s ease;
  margin-top: 20px;
}
.CreateApp_botSectionHeader__VRIbk {
  display: flex;
  align-items: center;
  gap: 10px;
  /* margin-bottom: 16px; */
  justify-content: center;
}

.CreateApp_botSectionIcon__ptT00 {
  font-size: 28px;
  line-height: 1;
}

.CreateApp_botSectionHeader__VRIbk h3 {
  font-size: 18px;
  font-weight: 600;
  color: #0a0a0a;
  margin: 0;
}

.CreateApp_botInfoIcon__BFyMW {
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s;
  margin-left: 2px;
}

.CreateApp_botInfoIcon__BFyMW:hover {
  color: #3b82f6;
}

.CreateApp_disabledNotice__BMOe4 {
  margin: 12px 0 0;
  padding: 10px 14px;
  background: #fef3c7;
  border-radius: 8px;
  color: #92400e;
  font-size: 13px;
  border-left: 3px solid #f59e0b;
}

/* Field Info Icon */
.CreateApp_fieldInfoIcon__VFgGd {
  color: #94a3b8;
  font-size: 14px;
  cursor: pointer;
  margin-left: 6px;
  transition: color 0.2s;
  vertical-align: middle;
}

.CreateApp_fieldInfoIcon__VFgGd:hover {
  color: #3b82f6;
}

/* Required Star */
.CreateApp_requiredStar__1bNo4 {
  color: #ef4444;
  font-weight: 600;
  margin-left: 2px;
}

/* Helper Text */
.CreateApp_helperText__5d6cz {
  font-size: 12px;
  color: #94a3b8;
  margin: 4px 0 0;
  line-height: 1.4;
}

/* Region Option Selected State */
.CreateApp_regionSelected__Uk5R6 {
  border-color: #3b82f6;
  background: #f0f7ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

/* Form Group spacing */
.CreateApp_formGroup__KALa3 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.CreateApp_formLabel__6fsD4 {
  font-size: 13px;
  font-weight: 600;
  color: #0a0a0a;
  display: flex;
  align-items: center;
}

.CreateApp_formInput__6v9\\+r,
.CreateApp_formSelect__1-uuz {
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  background: white;
}

.CreateApp_formInput__6v9\\+r:focus,
.CreateApp_formSelect__1-uuz:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.CreateApp_formSelect__1-uuz:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Region Options */
.CreateApp_regionOptions__65fXH {
  display: flex;
  gap: 12px;
}

.CreateApp_regionOption__c6UFZ {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s;
  background: white;
}

.CreateApp_regionOption__c6UFZ:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.CreateApp_regionOption__c6UFZ input[type="radio"] {
  accent-color: #3b82f6;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

/* Modal Content Styles - consistent with existing */
.CreateApp_modalContent__eFfCO h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.CreateApp_modalContent__eFfCO p {
  font-size: 14px;
  line-height: 1.6;
  color: #4a4a4a;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .CreateApp_regionOptions__65fXH {
    flex-direction: column;
    gap: 8px;
  }

  .CreateApp_regionOption__c6UFZ {
    width: 100%;
    justify-content: center;
  }

  .CreateApp_formLabel__6fsD4 {
    font-size: 13px;
    flex-wrap: wrap;
  }

  .CreateApp_fieldInfoIcon__VFgGd {
    margin-left: 4px;
  }
}

/* CreateApp.module.css - Modern Onboarding Styles */

.CreateApp_createContainer__nnLQh {
  display: flex;
  flex-direction: column;
  height: 90vh;
  width: 90%;
  margin: 35px auto;
  margin-bottom: 0px;
}

.CreateApp_header__INc7o {
  text-align: center;
  margin-bottom: 32px;
}

.CreateApp_mainTitle__AsGey {
  font-size: 32px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
  letter-spacing: -0.5px;
}

.CreateApp_subTitle__RwnZq {
  font-size: 16px;
  color: #64748b;
  margin: 8px 0 0;
}

.CreateApp_mainContainer__MBatu {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ============================================
   STEP INDICATOR - ENHANCED V2
   ============================================ */

.CreateApp_stepsContainer__V-TMq {
  padding: 20px 32px 16px;
  position: relative;
  background: white;
  border-radius: 16px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 4px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* Decorative gradient bar at top */
.CreateApp_stepsContainer__V-TMq::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    #6366f1,
    #8b5cf6,
    #a78bfa,
    #8b5cf6,
    #6366f1
  );
  background-size: 200% 100%;
  animation: CreateApp_shimmer__OW4Ms 4s ease-in-out infinite;
}

@keyframes CreateApp_shimmer__OW4Ms {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Subtle background pattern */
.CreateApp_stepsContainer__V-TMq::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(
      circle at 20% 50%,
      rgba(99, 102, 241, 0.03) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 50%,
      rgba(139, 92, 246, 0.03) 0%,
      transparent 50%
    );
  pointer-events: none;
  z-index: 0;
}

.CreateApp_stepIndicatorContainer__Snam9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  position: relative;
  padding: 12px 0 8px;
  z-index: 1;
}

/* Background connecting line */
.CreateApp_stepIndicatorContainer__Snam9::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 40px;
  right: 40px;
  height: 2px;
  background: #e2e8f0;
  transform: translateY(-50%);
  z-index: 0;
}

/* Progress fill line */
.CreateApp_stepIndicatorContainer__Snam9::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 40px;
  height: 2px;
  background: var(--gradient-hero);
  transform: translateY(-50%);
  z-index: 1;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  width: calc((100% - 80px) * var(--progress, 0));
}

.CreateApp_stepWrapper__VVeOn {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
  position: relative;
  z-index: 2;
}

.CreateApp_stepItem__efWaN {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  flex: 1 1;
  text-align: center;
  border-radius: 8px;
}

.CreateApp_stepItem__efWaN:hover:not(.CreateApp_stepSkipped__iVKgl) {
  transform: translateY(-2px);
}

.CreateApp_stepItem__efWaN:hover:not(.CreateApp_stepSkipped__iVKgl) .CreateApp_stepNumber__1hvrZ {
  transform: scale(1.1);
  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12);
}

.CreateApp_stepItem__efWaN:active:not(.CreateApp_stepSkipped__iVKgl) {
  transform: scale(0.95);
}

/* Step Number */
.CreateApp_stepNumber__1hvrZ {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  background: #f1f5f9;
  color: #94a3b8;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  border: 2px solid transparent;
  position: relative;
}

/* Active state with glow */
.CreateApp_stepActive__krOZv .CreateApp_stepNumber__1hvrZ {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: var(--white-color);
  border-color: #6366f1;
  box-shadow:
    0 0 0 4px rgba(99, 102, 241, 0.15),
    0 4px 12px rgba(99, 102, 241, 0.3);
  transform: scale(1.08);
}

/* Pulse ring for active step */
.CreateApp_stepActive__krOZv .CreateApp_stepNumber__1hvrZ::after {
  content: "";
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  border: 2px solid rgba(99, 102, 241, 0.25);
  animation: CreateApp_pulse-ring__01hsF 2.5s ease-out infinite;
}

@keyframes CreateApp_pulse-ring__01hsF {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

/* Completed state with checkmark */
.CreateApp_stepCompleted__uSJVn .CreateApp_stepNumber__1hvrZ {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border-color: #10b981;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
}

/* Skipped state */
.CreateApp_stepSkipped__iVKgl .CreateApp_stepNumber__1hvrZ {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
  border-color: #f59e0b;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
}

/* Step Label */
.CreateApp_stepLabel__lQJ\\+a {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  transition: all 0.3s ease;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-top: 2px;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
}

.CreateApp_stepActive__krOZv .CreateApp_stepLabel__lQJ\\+a {
  color: #1e293b;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.CreateApp_stepCompleted__uSJVn .CreateApp_stepLabel__lQJ\\+a {
  color: var(--saveBtn);
  font-weight: 600;
}

.CreateApp_stepSkipped__iVKgl .CreateApp_stepLabel__lQJ\\+a {
  color: var(--warning);
  font-weight: 600;
}

/* Skipped Badge */
.CreateApp_skippedBadge__a5Fxk {
  font-size: 8px;
  font-weight: 700;
  color: var(--warning);
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  padding: 1px 8px;
  border-radius: 10px;
  margin: auto;
  margin-top: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid rgba(245, 158, 11, 0.15);
  animation: CreateApp_badge-pulse__RXhuf 2s ease-in-out infinite;
}

@keyframes CreateApp_badge-pulse__RXhuf {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(0.95);
  }
}

/* Step Connector - Hidden (using progress bar instead) */
.CreateApp_stepConnector__-tuWI {
  display: none;
}

/* ============================================
   CONTENT AREA
   ============================================ */

.CreateApp_contentArea__lRHVt {
  display: flex;
  flex-direction: column;
  min-height: 480px;
}

.CreateApp_contentWrapper__G9UXT {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-evenly;
  padding: 40px;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  background: var(--gradient-bg);
}

/* ============================================
   NAVIGATION CONTROLS
   ============================================ */

.CreateApp_navigationControls__z5IR7 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 32px 0px;
  border-top: 1px solid #e2e8f0;
  gap: 20px;
}

.CreateApp_prevButton__mSO0P {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: var(--white-color);
  color: #475569;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.CreateApp_prevButton__mSO0P:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.CreateApp_prevButton__mSO0P:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.CreateApp_draftToggle__49EJR {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #475569;
}

.CreateApp_draftToggle__49EJR input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--primary-dark);
  cursor: pointer;
}

.CreateApp_nextButton__JXW87 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 28px;
  border: none;
  border-radius: 8px;
  background: var(--primary);
  color: var(--white-color);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.CreateApp_nextButton__JXW87:hover:not(.CreateApp_buttonDisabled__AJfSu) {
  background: var(--primary-hover);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.CreateApp_buttonDisabled__AJfSu,
.CreateApp_nextButton__JXW87:disabled {
  background: #94a3b8;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ============================================
   FRAMEWORK SELECTOR CARDS
   ============================================ */

.CreateApp_frameworkSelector__nzpCE {
  padding: 4px 0;
}

.CreateApp_frameworkGrid__3nuni {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.CreateApp_frameworkCard__fIMlC {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease,
    background 0.3s ease;
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  justify-content: space-between;
}

.CreateApp_frameworkCard__fIMlC:hover:not(.CreateApp_frameworkDisabled__zS0Wu) {
  border-color: #94a3b8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.CreateApp_frameworkCard__fIMlC input[type="radio"] {
  display: none;
}

.CreateApp_frameworkSelected__qlQKR {
  border-color: var(--primary-dark);
  background: #f0f7ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.08);
}

.CreateApp_frameworkDisabled__zS0Wu {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f8fafc;
}

.CreateApp_frameworkDisabled__zS0Wu:hover {
  transform: none;
  box-shadow: none;
}

.CreateApp_frameworkIcon__Gzhtd {
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 2px;
}

.CreateApp_frameworkContent__wV7OZ {
  flex: 1 1;
  min-width: 0;
  margin-top: 15px;
}

.CreateApp_frameworkTitle__i6t0R {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.CreateApp_frameworkBadge__KXX8P {
  font-size: 14px;
  font-weight: 700;
  color: var(--white-color);
  background: var(--gradient-success);
  border-radius: 50%;
  letter-spacing: 0.5px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.CreateApp_frameworkTitle__i6t0R strong {
  font-size: 16px;
  color: var(--heading);
}

.CreateApp_frameworkDescription__il1Am {
  font-size: 13px;
  color: var(--subheading);
  margin: 4px 0 0;
  line-height: 1.5;
}

.CreateApp_inProgressBadge__r\\+bhQ {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  color: var(--warning);
  background: #fef3c7;
  padding: 1px 10px;
  border-radius: 12px;
  margin-top: 4px;
}

.CreateApp_frameworkInfoIcon__sNle5 {
  color: #94a3b8;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 2px;
  transition: color 0.2s;
}

.CreateApp_frameworkInfoIcon__sNle5:hover {
  color: #3b82f6;
}

.CreateApp_infoText__Q8uO5 {
  font-size: 13px;
  color: #64748b;
  margin: 12px 0 0;
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 6px;
}

.CreateApp_infoIconSmall__6p4ko {
  color: #3b82f6;
  font-size: 13px;
}

/* ============================================
   FORM STYLES
   ============================================ */

.CreateApp_nameRegionContainer__Sx57a {
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  transition: border-color 0.2s ease;
  margin-top: 20px;
}

.CreateApp_formGroup__KALa3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.CreateApp_formLabel__6fsD4 {
  font-size: 13px;
  font-weight: 600;
  color: var(--heading);
}

.CreateApp_formInput__6v9\\+r,
.CreateApp_formSelect__1-uuz {
  padding: 20px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
  background: white;
}

.CreateApp_formInput__6v9\\+r:focus,
.CreateApp_formSelect__1-uuz:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.CreateApp_formSelect__1-uuz:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
}

.CreateApp_errorText__0rtB3 {
  font-size: 12px;
  color: #ef4444;
  margin: 4px 0 0;
}

.CreateApp_regionOptions__65fXH {
  display: flex;
  gap: 16px;
}

.CreateApp_regionOption__c6UFZ {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s;
}

.CreateApp_regionOption__c6UFZ:hover {
  border-color: #94a3b8;
}

.CreateApp_regionOption__c6UFZ input[type="radio"] {
  accent-color: #3b82f6;
  cursor: pointer;
}

/* ============================================
   STEP CONTENT
   ============================================ */

.CreateApp_stepContent__6HLP7 {
  padding: 4px 0;
}

.CreateApp_stepHeader__hfOd8 {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 20px;
}

.CreateApp_stepIconWrapper__3W9Aa {
  font-size: 32px;
  line-height: 1;
  flex-shrink: 0;
}

.CreateApp_stepTitle__ydkbS {
  font-size: 20px;
  font-weight: 600;
  color: #0a0a0a;
  margin: 0;
}

.CreateApp_stepDescription__kylRK {
  font-size: 14px;
  color: #64748b;
  margin: 4px 0 0;
}

.CreateApp_stepBody__DbZ7V {
  padding: 4px 0;
}

/* ============================================
   RESPONSIVE STEPS
   ============================================ */

/* Tablet */
@media (max-width: 1024px) {
  .CreateApp_stepsContainer__V-TMq {
    padding: 16px 24px 12px;
  }

  .CreateApp_stepNumber__1hvrZ {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .CreateApp_stepLabel__lQJ\\+a {
    font-size: 11px;
    white-space: inherit;
  }

  .CreateApp_stepItem__efWaN {
    padding: 4px 6px;
    gap: 4px;
  }

  .CreateApp_stepIndicatorContainer__Snam9::before,
  .CreateApp_stepIndicatorContainer__Snam9::after {
    left: 32px;
    right: 32px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  /* .createContainer {
    padding: 16px;
  } */

  .CreateApp_mainTitle__AsGey {
    font-size: 24px;
  }

  .CreateApp_stepsContainer__V-TMq {
    padding: 14px 16px 12px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Custom scrollbar */
  .CreateApp_stepsContainer__V-TMq::-webkit-scrollbar {
    height: 3px;
  }

  .CreateApp_stepsContainer__V-TMq::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }

  .CreateApp_stepsContainer__V-TMq::-webkit-scrollbar-thumb {
    background: linear-gradient(90deg, #6366f1, #8b5cf6);
    border-radius: 3px;
  }

  .CreateApp_stepIndicatorContainer__Snam9 {
    min-width: 500px;
    padding: 8px 0;
  }

  .CreateApp_stepIndicatorContainer__Snam9::before,
  .CreateApp_stepIndicatorContainer__Snam9::after {
    left: 28px;
    right: 28px;
  }

  .CreateApp_stepLabel__lQJ\\+a {
    font-size: 10px;
    letter-spacing: 0.2px;
    white-space: inherit;
  }

  .CreateApp_stepNumber__1hvrZ {
    width: 28px;
    height: 28px;
    font-size: 11px;
  }

  .CreateApp_stepItem__efWaN {
    padding: 2px 4px;
    gap: 10px;
  }

  .CreateApp_skippedBadge__a5Fxk {
    font-size: 7px;
    padding: 1px 6px;
  }

  .CreateApp_stepsContainer__V-TMq::before {
    height: 2px;
  }

  .CreateApp_stepActive__krOZv .CreateApp_stepNumber__1hvrZ::after {
    inset: -4px;
    border-width: 1.5px;
  }

  .CreateApp_contentWrapper__G9UXT {
    padding: 20px;
  }

  .CreateApp_frameworkGrid__3nuni {
    grid-template-columns: 1fr;
  }

  .CreateApp_navigationControls__z5IR7 {
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 20px 20px;
  }

  .CreateApp_draftToggle__49EJR {
    order: 3;
    width: 100%;
    justify-content: center;
  }

  .CreateApp_prevButton__mSO0P {
    order: 1;
  }

  .CreateApp_nextButton__JXW87 {
    order: 2;
  }

  .CreateApp_nameRegionContainer__Sx57a {
    max-width: 100%;
  }

  .CreateApp_header__INc7o {
    margin-bottom: 20px;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .CreateApp_stepsContainer__V-TMq {
    padding: 12px 12px 10px;
  }

  .CreateApp_stepIndicatorContainer__Snam9 {
    min-width: 400px;
  }

  .CreateApp_stepIndicatorContainer__Snam9::before,
  .CreateApp_stepIndicatorContainer__Snam9::after {
    left: 20px;
    right: 20px;
  }

  .CreateApp_stepNumber__1hvrZ {
    width: 24px;
    height: 24px;
    font-size: 10px;
    border-width: 1.5px;
  }

  .CreateApp_stepLabel__lQJ\\+a {
    font-size: 9px;
  }

  .CreateApp_stepItem__efWaN {
    padding: 2px 3px;
    gap: 3px;
  }

  /* Disable pulse on very small screens */
  .CreateApp_stepActive__krOZv .CreateApp_stepNumber__1hvrZ::after {
    display: none;
  }

  .CreateApp_stepItem__efWaN:hover:not(.CreateApp_stepSkipped__iVKgl) .CreateApp_stepNumber__1hvrZ {
    transform: scale(1.05);
  }

  .CreateApp_frameworkCard__fIMlC {
    padding: 12px 14px;
  }

  .CreateApp_frameworkTitle__i6t0R strong {
    font-size: 13px;
  }

  .CreateApp_frameworkDescription__il1Am {
    font-size: 12px;
  }

  .CreateApp_regionOptions__65fXH {
    flex-direction: column;
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewCreateAppF/CreateApp.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf;;mBAEiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;iDAEiD;;AAEjD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB;;kCAEgC;EAChC,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;;GAOC;EACD,0BAA0B;EAC1B,2DAA0C;AAC5C;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;KAUG;EACH,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,MAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,2BAA2B;EAC3B,UAAU;EACV,mDAAmD;EACnD,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,SAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iDAAiD;EACjD,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,yBAAyB;EACzB,qBAAqB;EACrB;;sCAEoC;EACpC,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,6DAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,mCAAmC;AACnC;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;EACrD,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,+DAA8C;AAChD;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf;;;wBAGsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD,WAAW;AACX;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;;KAEG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,qBAAqB;EACrB;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,oDAAoD;IACpD,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA,wCAAwC;EACxC;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".draftHint {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n/* ───────────────────────── Questionnaire (Step 3) ───────────────────────── */\n\n.questionnaireSection {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.questionnaireHeader {\n  margin-bottom: 4px;\n}\n\n.questionnaireHeader h4 {\n  margin: 0 0 6px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #0a0a0a;\n}\n\n.questionnaireHeader p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.questionTile {\n  padding: 20px 22px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.questionLabelRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.questionLabel {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0a0a0a;\n  margin-bottom: 4px;\n}\n\n.questionSubtext {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.questionInfoBtn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.questionInfoBtn:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n  background: #f0f7ff;\n}\n\n.questionInfoPanel {\n  margin-bottom: 16px;\n  padding: 16px 18px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-left: 3px solid #3b82f6;\n  border-radius: 8px;\n  font-size: 13px;\n  line-height: 1.7;\n  color: #334155;\n}\n\n.questionInfoPanel p {\n  margin: 0 0 10px 0;\n}\n\n.questionInfoPanel p:last-child {\n  margin-bottom: 0;\n}\n\n.questionInfoPanel ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.questionInfoPanel li {\n  margin-bottom: 6px;\n}\n\n.choiceRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.choiceCard {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  position: relative;\n  text-align: left;\n}\n\n.choiceCard:hover {\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.choiceCard input[type=\"radio\"],\n.choiceCard input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.choiceCardActive {\n  border-color: #3b82f6;\n  background: #f0f7ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);\n}\n\n.choiceIcon {\n  font-size: 22px;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.choiceTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0a0a0a;\n  line-height: 1.3;\n}\n\n.choiceHint {\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n@media (max-width: 640px) {\n  .questionLabelRow {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .questionInfoBtn {\n    align-self: flex-start;\n  }\n\n  .choiceRow {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ───────────────────────── Questionnaire (Step 3) ───────────────────────── */\n\n.questionnaireSection {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.questionnaireHeader {\n  margin-bottom: 4px;\n}\n\n.questionnaireHeader h4 {\n  margin: 0 0 6px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #0a0a0a;\n}\n\n.questionnaireHeader p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.questionTile {\n  padding: 20px 22px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.questionLabelRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.questionLabel {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0a0a0a;\n  margin-bottom: 4px;\n}\n\n.questionSubtext {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.questionInfoBtn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.questionInfoBtn:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n  background: #f0f7ff;\n}\n\n.questionInfoPanel {\n  margin-bottom: 16px;\n  padding: 16px 18px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-left: 3px solid #3b82f6;\n  border-radius: 8px;\n  font-size: 13px;\n  line-height: 1.7;\n  color: #334155;\n}\n\n.questionInfoPanel p {\n  margin: 0 0 10px 0;\n}\n\n.questionInfoPanel p:last-child {\n  margin-bottom: 0;\n}\n\n.questionInfoPanel ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.questionInfoPanel li {\n  margin-bottom: 6px;\n}\n\n.choiceRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.choiceCard {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  position: relative;\n  text-align: left;\n}\n\n.choiceCard:hover {\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.choiceCard input[type=\"radio\"],\n.choiceCard input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.choiceCardActive {\n  border-color: #3b82f6;\n  background: #f0f7ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);\n}\n\n.choiceIcon {\n  font-size: 22px;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.choiceTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0a0a0a;\n  line-height: 1.3;\n}\n\n.choiceHint {\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .questionLabelRow {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .questionInfoBtn {\n    align-self: flex-start;\n  }\n\n  .choiceRow {\n    grid-template-columns: 1fr;\n  }\n}\n\n.modalOpener {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n/* Bot Section Styles - Updated */\n.botSection {\n  padding: 4px 0;\n  width: 100%;\n}\n.wrap_welcome_message {\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n  transition: border-color 0.2s ease;\n  margin-top: 20px;\n}\n.botSectionHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* margin-bottom: 16px; */\n  justify-content: center;\n}\n\n.botSectionIcon {\n  font-size: 28px;\n  line-height: 1;\n}\n\n.botSectionHeader h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0a0a0a;\n  margin: 0;\n}\n\n.botInfoIcon {\n  color: #94a3b8;\n  font-size: 16px;\n  cursor: pointer;\n  transition: color 0.2s;\n  margin-left: 2px;\n}\n\n.botInfoIcon:hover {\n  color: #3b82f6;\n}\n\n.disabledNotice {\n  margin: 12px 0 0;\n  padding: 10px 14px;\n  background: #fef3c7;\n  border-radius: 8px;\n  color: #92400e;\n  font-size: 13px;\n  border-left: 3px solid #f59e0b;\n}\n\n/* Field Info Icon */\n.fieldInfoIcon {\n  color: #94a3b8;\n  font-size: 14px;\n  cursor: pointer;\n  margin-left: 6px;\n  transition: color 0.2s;\n  vertical-align: middle;\n}\n\n.fieldInfoIcon:hover {\n  color: #3b82f6;\n}\n\n/* Required Star */\n.requiredStar {\n  color: #ef4444;\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n/* Helper Text */\n.helperText {\n  font-size: 12px;\n  color: #94a3b8;\n  margin: 4px 0 0;\n  line-height: 1.4;\n}\n\n/* Region Option Selected State */\n.regionSelected {\n  border-color: #3b82f6;\n  background: #f0f7ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);\n}\n\n/* Form Group spacing */\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.formLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0a0a0a;\n  display: flex;\n  align-items: center;\n}\n\n.formInput,\n.formSelect {\n  padding: 10px 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  background: white;\n}\n\n.formInput:focus,\n.formSelect:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.formSelect:disabled {\n  background: #f1f5f9;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Region Options */\n.regionOptions {\n  display: flex;\n  gap: 12px;\n}\n\n.regionOption {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 16px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  transition: all 0.2s;\n  background: white;\n}\n\n.regionOption:hover {\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.regionOption input[type=\"radio\"] {\n  accent-color: #3b82f6;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n\n/* Modal Content Styles - consistent with existing */\n.modalContent h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 8px 0;\n}\n\n.modalContent p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #4a4a4a;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .regionOptions {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .regionOption {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .formLabel {\n    font-size: 13px;\n    flex-wrap: wrap;\n  }\n\n  .fieldInfoIcon {\n    margin-left: 4px;\n  }\n}\n\n/* CreateApp.module.css - Modern Onboarding Styles */\n\n.createContainer {\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n  width: 90%;\n  margin: 35px auto;\n  margin-bottom: 0px;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.mainTitle {\n  font-size: 32px;\n  font-weight: 700;\n  color: #0a0a0a;\n  margin: 0;\n  letter-spacing: -0.5px;\n}\n\n.subTitle {\n  font-size: 16px;\n  color: #64748b;\n  margin: 8px 0 0;\n}\n\n.mainContainer {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ============================================\n   STEP INDICATOR - ENHANCED V2\n   ============================================ */\n\n.stepsContainer {\n  padding: 20px 32px 16px;\n  position: relative;\n  background: white;\n  border-radius: 16px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.06),\n    0 4px 12px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n/* Decorative gradient bar at top */\n.stepsContainer::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(\n    90deg,\n    #6366f1,\n    #8b5cf6,\n    #a78bfa,\n    #8b5cf6,\n    #6366f1\n  );\n  background-size: 200% 100%;\n  animation: shimmer 4s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Subtle background pattern */\n.stepsContainer::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image:\n    radial-gradient(\n      circle at 20% 50%,\n      rgba(99, 102, 241, 0.03) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 50%,\n      rgba(139, 92, 246, 0.03) 0%,\n      transparent 50%\n    );\n  pointer-events: none;\n  z-index: 0;\n}\n\n.stepIndicatorContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0;\n  position: relative;\n  padding: 12px 0 8px;\n  z-index: 1;\n}\n\n/* Background connecting line */\n.stepIndicatorContainer::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 40px;\n  right: 40px;\n  height: 2px;\n  background: #e2e8f0;\n  transform: translateY(-50%);\n  z-index: 0;\n}\n\n/* Progress fill line */\n.stepIndicatorContainer::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 40px;\n  height: 2px;\n  background: var(--gradient-hero);\n  transform: translateY(-50%);\n  z-index: 1;\n  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  width: calc((100% - 80px) * var(--progress, 0));\n}\n\n.stepWrapper {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  z-index: 2;\n}\n\n.stepItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  padding: 4px 8px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  flex: 1;\n  text-align: center;\n  border-radius: 8px;\n}\n\n.stepItem:hover:not(.stepSkipped) {\n  transform: translateY(-2px);\n}\n\n.stepItem:hover:not(.stepSkipped) .stepNumber {\n  transform: scale(1.1);\n  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12);\n}\n\n.stepItem:active:not(.stepSkipped) {\n  transform: scale(0.95);\n}\n\n/* Step Number */\n.stepNumber {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  background: #f1f5f9;\n  color: #94a3b8;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0;\n  border: 2px solid transparent;\n  position: relative;\n}\n\n/* Active state with glow */\n.stepActive .stepNumber {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: var(--white-color);\n  border-color: #6366f1;\n  box-shadow:\n    0 0 0 4px rgba(99, 102, 241, 0.15),\n    0 4px 12px rgba(99, 102, 241, 0.3);\n  transform: scale(1.08);\n}\n\n/* Pulse ring for active step */\n.stepActive .stepNumber::after {\n  content: \"\";\n  position: absolute;\n  inset: -5px;\n  border-radius: 50%;\n  border: 2px solid rgba(99, 102, 241, 0.25);\n  animation: pulse-ring 2.5s ease-out infinite;\n}\n\n@keyframes pulse-ring {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.4);\n    opacity: 0;\n  }\n}\n\n/* Completed state with checkmark */\n.stepCompleted .stepNumber {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  border-color: #10b981;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);\n}\n\n/* Skipped state */\n.stepSkipped .stepNumber {\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  color: white;\n  border-color: #f59e0b;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);\n}\n\n/* Step Label */\n.stepLabel {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  transition: all 0.3s ease;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  margin-top: 2px;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: column;\n}\n\n.stepActive .stepLabel {\n  color: #1e293b;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.stepCompleted .stepLabel {\n  color: var(--saveBtn);\n  font-weight: 600;\n}\n\n.stepSkipped .stepLabel {\n  color: var(--warning);\n  font-weight: 600;\n}\n\n/* Skipped Badge */\n.skippedBadge {\n  font-size: 8px;\n  font-weight: 700;\n  color: var(--warning);\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\n  padding: 1px 8px;\n  border-radius: 10px;\n  margin: auto;\n  margin-top: 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border: 1px solid rgba(245, 158, 11, 0.15);\n  animation: badge-pulse 2s ease-in-out infinite;\n}\n\n@keyframes badge-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(0.95);\n  }\n}\n\n/* Step Connector - Hidden (using progress bar instead) */\n.stepConnector {\n  display: none;\n}\n\n/* ============================================\n   CONTENT AREA\n   ============================================ */\n\n.contentArea {\n  display: flex;\n  flex-direction: column;\n  min-height: 480px;\n}\n\n.contentWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-evenly;\n  padding: 40px;\n  border: 1px solid #e2e2e2;\n  border-radius: 10px;\n  background: var(--gradient-bg);\n}\n\n/* ============================================\n   NAVIGATION CONTROLS\n   ============================================ */\n\n.navigationControls {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 32px 0px;\n  border-top: 1px solid #e2e8f0;\n  gap: 20px;\n}\n\n.prevButton {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 20px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: var(--white-color);\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.prevButton:hover:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.prevButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.draftToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.draftToggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--primary-dark);\n  cursor: pointer;\n}\n\n.nextButton {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 28px;\n  border: none;\n  border-radius: 8px;\n  background: var(--primary);\n  color: var(--white-color);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.nextButton:hover:not(.buttonDisabled) {\n  background: var(--primary-hover);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.buttonDisabled,\n.nextButton:disabled {\n  background: #94a3b8;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* ============================================\n   FRAMEWORK SELECTOR CARDS\n   ============================================ */\n\n.frameworkSelector {\n  padding: 4px 0;\n}\n\n.frameworkGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.frameworkCard {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease,\n    background 0.3s ease;\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n  justify-content: space-between;\n}\n\n.frameworkCard:hover:not(.frameworkDisabled) {\n  border-color: #94a3b8;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.frameworkCard input[type=\"radio\"] {\n  display: none;\n}\n\n.frameworkSelected {\n  border-color: var(--primary-dark);\n  background: #f0f7ff;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.08);\n}\n\n.frameworkDisabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #f8fafc;\n}\n\n.frameworkDisabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.frameworkIcon {\n  font-size: 24px;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.frameworkContent {\n  flex: 1;\n  min-width: 0;\n  margin-top: 15px;\n}\n\n.frameworkTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.frameworkBadge {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--white-color);\n  background: var(--gradient-success);\n  border-radius: 50%;\n  letter-spacing: 0.5px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.frameworkTitle strong {\n  font-size: 16px;\n  color: var(--heading);\n}\n\n.frameworkDescription {\n  font-size: 13px;\n  color: var(--subheading);\n  margin: 4px 0 0;\n  line-height: 1.5;\n}\n\n.inProgressBadge {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--warning);\n  background: #fef3c7;\n  padding: 1px 10px;\n  border-radius: 12px;\n  margin-top: 4px;\n}\n\n.frameworkInfoIcon {\n  color: #94a3b8;\n  font-size: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-top: 2px;\n  transition: color 0.2s;\n}\n\n.frameworkInfoIcon:hover {\n  color: #3b82f6;\n}\n\n.infoText {\n  font-size: 13px;\n  color: #64748b;\n  margin: 12px 0 0;\n  font-style: italic;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.infoIconSmall {\n  color: #3b82f6;\n  font-size: 13px;\n}\n\n/* ============================================\n   FORM STYLES\n   ============================================ */\n\n.nameRegionContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  width: 100%;\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n  transition: border-color 0.2s ease;\n  margin-top: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.formLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--heading);\n}\n\n.formInput,\n.formSelect {\n  padding: 20px 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  background: white;\n}\n\n.formInput:focus,\n.formSelect:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.formSelect:disabled {\n  background: #f1f5f9;\n  cursor: not-allowed;\n}\n\n.errorText {\n  font-size: 12px;\n  color: #ef4444;\n  margin: 4px 0 0;\n}\n\n.regionOptions {\n  display: flex;\n  gap: 16px;\n}\n\n.regionOption {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 6px 12px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.regionOption:hover {\n  border-color: #94a3b8;\n}\n\n.regionOption input[type=\"radio\"] {\n  accent-color: #3b82f6;\n  cursor: pointer;\n}\n\n/* ============================================\n   STEP CONTENT\n   ============================================ */\n\n.stepContent {\n  padding: 4px 0;\n}\n\n.stepHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.stepIconWrapper {\n  font-size: 32px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.stepTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0a0a0a;\n  margin: 0;\n}\n\n.stepDescription {\n  font-size: 14px;\n  color: #64748b;\n  margin: 4px 0 0;\n}\n\n.stepBody {\n  padding: 4px 0;\n}\n\n/* ============================================\n   RESPONSIVE STEPS\n   ============================================ */\n\n/* Tablet */\n@media (max-width: 1024px) {\n  .stepsContainer {\n    padding: 16px 24px 12px;\n  }\n\n  .stepNumber {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  .stepLabel {\n    font-size: 11px;\n    white-space: inherit;\n  }\n\n  .stepItem {\n    padding: 4px 6px;\n    gap: 4px;\n  }\n\n  .stepIndicatorContainer::before,\n  .stepIndicatorContainer::after {\n    left: 32px;\n    right: 32px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  /* .createContainer {\n    padding: 16px;\n  } */\n\n  .mainTitle {\n    font-size: 24px;\n  }\n\n  .stepsContainer {\n    padding: 14px 16px 12px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Custom scrollbar */\n  .stepsContainer::-webkit-scrollbar {\n    height: 3px;\n  }\n\n  .stepsContainer::-webkit-scrollbar-track {\n    background: #f1f5f9;\n    border-radius: 3px;\n  }\n\n  .stepsContainer::-webkit-scrollbar-thumb {\n    background: linear-gradient(90deg, #6366f1, #8b5cf6);\n    border-radius: 3px;\n  }\n\n  .stepIndicatorContainer {\n    min-width: 500px;\n    padding: 8px 0;\n  }\n\n  .stepIndicatorContainer::before,\n  .stepIndicatorContainer::after {\n    left: 28px;\n    right: 28px;\n  }\n\n  .stepLabel {\n    font-size: 10px;\n    letter-spacing: 0.2px;\n    white-space: inherit;\n  }\n\n  .stepNumber {\n    width: 28px;\n    height: 28px;\n    font-size: 11px;\n  }\n\n  .stepItem {\n    padding: 2px 4px;\n    gap: 10px;\n  }\n\n  .skippedBadge {\n    font-size: 7px;\n    padding: 1px 6px;\n  }\n\n  .stepsContainer::before {\n    height: 2px;\n  }\n\n  .stepActive .stepNumber::after {\n    inset: -4px;\n    border-width: 1.5px;\n  }\n\n  .contentWrapper {\n    padding: 20px;\n  }\n\n  .frameworkGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .navigationControls {\n    flex-wrap: wrap;\n    gap: 12px;\n    padding: 16px 20px 20px;\n  }\n\n  .draftToggle {\n    order: 3;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .prevButton {\n    order: 1;\n  }\n\n  .nextButton {\n    order: 2;\n  }\n\n  .nameRegionContainer {\n    max-width: 100%;\n  }\n\n  .header {\n    margin-bottom: 20px;\n  }\n}\n\n/* Small mobile */\n@media (max-width: 480px) {\n  .stepsContainer {\n    padding: 12px 12px 10px;\n  }\n\n  .stepIndicatorContainer {\n    min-width: 400px;\n  }\n\n  .stepIndicatorContainer::before,\n  .stepIndicatorContainer::after {\n    left: 20px;\n    right: 20px;\n  }\n\n  .stepNumber {\n    width: 24px;\n    height: 24px;\n    font-size: 10px;\n    border-width: 1.5px;\n  }\n\n  .stepLabel {\n    font-size: 9px;\n  }\n\n  .stepItem {\n    padding: 2px 3px;\n    gap: 3px;\n  }\n\n  /* Disable pulse on very small screens */\n  .stepActive .stepNumber::after {\n    display: none;\n  }\n\n  .stepItem:hover:not(.stepSkipped) .stepNumber {\n    transform: scale(1.05);\n  }\n\n  .frameworkCard {\n    padding: 12px 14px;\n  }\n\n  .frameworkTitle strong {\n    font-size: 13px;\n  }\n\n  .frameworkDescription {\n    font-size: 12px;\n  }\n\n  .regionOptions {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draftHint": `CreateApp_draftHint__8Jmeq`,
	"questionnaireSection": `CreateApp_questionnaireSection__3U0qE`,
	"questionnaireHeader": `CreateApp_questionnaireHeader__nfOzq`,
	"questionTile": `CreateApp_questionTile__RUYyx`,
	"questionLabelRow": `CreateApp_questionLabelRow__Neu49`,
	"questionLabel": `CreateApp_questionLabel__l+CVh`,
	"questionSubtext": `CreateApp_questionSubtext__CqD++`,
	"questionInfoBtn": `CreateApp_questionInfoBtn__aTnA1`,
	"questionInfoPanel": `CreateApp_questionInfoPanel__gVPls`,
	"choiceRow": `CreateApp_choiceRow__A+7so`,
	"choiceCard": `CreateApp_choiceCard__rXB2j`,
	"choiceCardActive": `CreateApp_choiceCardActive__sFerY`,
	"choiceIcon": `CreateApp_choiceIcon__mSkuz`,
	"choiceTitle": `CreateApp_choiceTitle__ppMzc`,
	"choiceHint": `CreateApp_choiceHint__-OjoG`,
	"modalOpener": `CreateApp_modalOpener__r7Ri4`,
	"botSection": `CreateApp_botSection__a36B3`,
	"wrap_welcome_message": `CreateApp_wrap_welcome_message__qKUuC`,
	"botSectionHeader": `CreateApp_botSectionHeader__VRIbk`,
	"botSectionIcon": `CreateApp_botSectionIcon__ptT00`,
	"botInfoIcon": `CreateApp_botInfoIcon__BFyMW`,
	"disabledNotice": `CreateApp_disabledNotice__BMOe4`,
	"fieldInfoIcon": `CreateApp_fieldInfoIcon__VFgGd`,
	"requiredStar": `CreateApp_requiredStar__1bNo4`,
	"helperText": `CreateApp_helperText__5d6cz`,
	"regionSelected": `CreateApp_regionSelected__Uk5R6`,
	"formGroup": `CreateApp_formGroup__KALa3`,
	"formLabel": `CreateApp_formLabel__6fsD4`,
	"formInput": `CreateApp_formInput__6v9+r`,
	"formSelect": `CreateApp_formSelect__1-uuz`,
	"regionOptions": `CreateApp_regionOptions__65fXH`,
	"regionOption": `CreateApp_regionOption__c6UFZ`,
	"modalContent": `CreateApp_modalContent__eFfCO`,
	"createContainer": `CreateApp_createContainer__nnLQh`,
	"header": `CreateApp_header__INc7o`,
	"mainTitle": `CreateApp_mainTitle__AsGey`,
	"subTitle": `CreateApp_subTitle__RwnZq`,
	"mainContainer": `CreateApp_mainContainer__MBatu`,
	"stepsContainer": `CreateApp_stepsContainer__V-TMq`,
	"shimmer": `CreateApp_shimmer__OW4Ms`,
	"stepIndicatorContainer": `CreateApp_stepIndicatorContainer__Snam9`,
	"stepWrapper": `CreateApp_stepWrapper__VVeOn`,
	"stepItem": `CreateApp_stepItem__efWaN`,
	"stepSkipped": `CreateApp_stepSkipped__iVKgl`,
	"stepNumber": `CreateApp_stepNumber__1hvrZ`,
	"stepActive": `CreateApp_stepActive__krOZv`,
	"pulse-ring": `CreateApp_pulse-ring__01hsF`,
	"stepCompleted": `CreateApp_stepCompleted__uSJVn`,
	"stepLabel": `CreateApp_stepLabel__lQJ+a`,
	"skippedBadge": `CreateApp_skippedBadge__a5Fxk`,
	"badge-pulse": `CreateApp_badge-pulse__RXhuf`,
	"stepConnector": `CreateApp_stepConnector__-tuWI`,
	"contentArea": `CreateApp_contentArea__lRHVt`,
	"contentWrapper": `CreateApp_contentWrapper__G9UXT`,
	"navigationControls": `CreateApp_navigationControls__z5IR7`,
	"prevButton": `CreateApp_prevButton__mSO0P`,
	"draftToggle": `CreateApp_draftToggle__49EJR`,
	"nextButton": `CreateApp_nextButton__JXW87`,
	"buttonDisabled": `CreateApp_buttonDisabled__AJfSu`,
	"frameworkSelector": `CreateApp_frameworkSelector__nzpCE`,
	"frameworkGrid": `CreateApp_frameworkGrid__3nuni`,
	"frameworkCard": `CreateApp_frameworkCard__fIMlC`,
	"frameworkDisabled": `CreateApp_frameworkDisabled__zS0Wu`,
	"frameworkSelected": `CreateApp_frameworkSelected__qlQKR`,
	"frameworkIcon": `CreateApp_frameworkIcon__Gzhtd`,
	"frameworkContent": `CreateApp_frameworkContent__wV7OZ`,
	"frameworkTitle": `CreateApp_frameworkTitle__i6t0R`,
	"frameworkBadge": `CreateApp_frameworkBadge__KXX8P`,
	"frameworkDescription": `CreateApp_frameworkDescription__il1Am`,
	"inProgressBadge": `CreateApp_inProgressBadge__r+bhQ`,
	"frameworkInfoIcon": `CreateApp_frameworkInfoIcon__sNle5`,
	"infoText": `CreateApp_infoText__Q8uO5`,
	"infoIconSmall": `CreateApp_infoIconSmall__6p4ko`,
	"nameRegionContainer": `CreateApp_nameRegionContainer__Sx57a`,
	"errorText": `CreateApp_errorText__0rtB3`,
	"stepContent": `CreateApp_stepContent__6HLP7`,
	"stepHeader": `CreateApp_stepHeader__hfOd8`,
	"stepIconWrapper": `CreateApp_stepIconWrapper__3W9Aa`,
	"stepTitle": `CreateApp_stepTitle__ydkbS`,
	"stepDescription": `CreateApp_stepDescription__kylRK`,
	"stepBody": `CreateApp_stepBody__DbZ7V`
};
export default ___CSS_LOADER_EXPORT___;
